import graphql__9d9a527334386e80d913 from "./__generated__/ContributionWithRequiredModerationBadge_contribution.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../../Intl/Context";
import Tooltip from "../../Tooltip/Tooltip";
import Icon from "../../Utils/Icon";

const ContributionWithRequiredModerationBadge = props => {
  const contribution = useFragment(
    ContributionWithRequiredModerationBadge_contribution,
    props.contribution
  );
  const { requiresModeration } = contribution.authorizations;

  const t = useFormatMessage();
  const label = t(intlMessages.label);
  const tooltip = t(intlMessages.tooltip);

  const className = classNames(
    "d-inline-flex",
    "align-items-center",
    "bg-danger",
    "text-primary-inverse",
    "padding-xxs",
    "rounded",
    "text-btn-xs",
    props.className
  );

  if (!requiresModeration) return null;

  return (
    <Tooltip content={tooltip}>
      <div className={className}>
        <Icon className="fa fa-exclamation-triangle text-btn-xxs margin-right-xxs" />
        {label}
      </div>
    </Tooltip>
  );
};

const ContributionWithRequiredModerationBadge_contribution = graphql__9d9a527334386e80d913;

export default ContributionWithRequiredModerationBadge;

const intlMessages = defineMessages({
  label: {
    id: "contribution.requiresModerationBadge.label",
    defaultMessage: "Visible par vous uniquement"
  },
  tooltip: {
    id: "contribution.requiresModerationBadge.tooltip",
    defaultMessage: `
      Cette contribution est actuellement en attente de modération par un administrateur 
      de la plateforme, et est donc uniquement visible par vous.
    `
  }
});
